import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Error inesperado" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8" data-testid="error-boundary">
          <div className="bg-card border border-[#E11D48]/30 rounded-sm p-6 max-w-xl">
            <h2 className="font-heading text-xl font-bold tracking-tight text-[#E11D48]">Ocurrió un error al mostrar esta sección</h2>
            <p className="text-sm text-muted-foreground mt-2">{this.state.message}</p>
            <button
              className="mt-4 px-4 py-2 rounded-sm bg-[#DC2626] text-white text-sm"
              onClick={() => this.setState({ hasError: false, message: "" })}
              data-testid="error-retry-button"
            >
              Reintentar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
